import { render } from "./Age.vue?vue&type=template&id=074b06d0&scoped=true"
import script from "./Age.vue?vue&type=script&lang=js"
export * from "./Age.vue?vue&type=script&lang=js"

import "./Age.vue?vue&type=style&index=0&id=074b06d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074b06d0"],['__file',"src/apps/quiz/routes/Age.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "074b06d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('074b06d0', __exports__)) {
    api.reload('074b06d0', __exports__)
  }
  
  module.hot.accept("./Age.vue?vue&type=template&id=074b06d0&scoped=true", () => {
    api.rerender('074b06d0', render)
  })

}


export default __exports__